import React from 'react';
import { ImageContentPreview } from '../../paths/components/authoring/content/fields/ImageContent';
import { VideoContentPreview } from '../../paths/components/authoring/content/fields/VideoContent';
import { EmbedCodeContentPreview } from '../../paths/components/authoring/content/fields/EmbedCodeContent';
import { ButtonContentPreview } from '../../paths/components/authoring/content/fields/ButtonContent';
import EditorPreviewEmbed from '../../walkthroughs/EditorPreviewEmbed';

// BL-118 — read-only render of a Doc block, used by the preview and the learner
// reader. Text blocks keep their simple Word-doc styling; the rich elements
// (image, video, embed, button, walkthrough) reuse the real Path learner
// renderers, so a walkthrough runs INTERACTIVELY inline via EditorPreviewEmbed.
const BlockRenderer = ({ block }) => {
  const text = block.text || '';
  switch (block.type) {
    case 'h1': return <h1 id={`blk-${block.id}`} className="doc-r-h1">{text}</h1>;
    case 'h2': return <h2 id={`blk-${block.id}`} className="doc-r-h2">{text}</h2>;
    case 'h3': return <h3 id={`blk-${block.id}`} className="doc-r-h3">{text}</h3>;
    case 'quote': return <blockquote className="doc-r-quote">{text}</blockquote>;
    case 'callout': return <div className="doc-r-callout">{text}</div>;
    case 'divider': return <hr className="doc-r-hr" />;
    case 'image':
      return block.source ? <div className="doc-r-el"><ImageContentPreview layer={{ source: block.source }} /></div> : null;
    case 'video':
      return block.source ? <div className="doc-r-el"><VideoContentPreview layer={{ source: block.source }} /></div> : null;
    case 'embed':
      return block.source ? <div className="doc-r-el"><EmbedCodeContentPreview layer={{ source: block.source }} /></div> : null;
    case 'button':
      return <div className="doc-r-el"><ButtonContentPreview layer={{ content: block.label, action: 'link', destination: block.destination }} /></div>;
    case 'walkthrough':
      return block.source
        ? <div className="doc-r-el doc-r-wtembed"><EditorPreviewEmbed id={block.source} parent_visibility="public" /></div>
        : null;
    case 'text':
    default:
      return text ? <p className="doc-r-text">{text}</p> : null;
  }
};

export default BlockRenderer;
